"use client";

import * as React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { FileText, ArrowRight } from "lucide-react";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function Advisory() {
  const shouldReduceMotion = useReducedMotion();
  const motionProps = shouldReduceMotion ? {
    initial: {
      opacity: 1,
      y: 0
    },
    animate: {
      opacity: 1,
      y: 0
    }
  } : {
    initial: {
      opacity: 0,
      y: 12
    },
    whileInView: {
      opacity: 1,
      y: 0
    },
    viewport: {
      once: true,
      amount: 0.2
    },
    transition: {
      duration: 0.3,
      ease: [0.16, 1, 0.3, 1]
    }
  };
  return <section id="enquiryprocessadvisory" data-nav="light" className="relative w-full bg-background text-foreground py-16 md:py-24 border-b border-border">
      <div className="container mx-auto max-w-4xl px-4 sm:px-6">
        <motion.div {...motionProps}>
          <Card className="rounded-none border border-border bg-card shadow-sm p-6 sm:p-10 md:p-12">
            <CardHeader className="p-0 space-y-4">
              <div className="flex items-center gap-2">
                <Badge variant="outline" className="rounded-none border-border bg-muted/60 text-muted-foreground font-mono text-xs uppercase tracking-wider px-2.5 py-1 flex items-center gap-1.5">
                  <FileText className="size-3 text-primary" />
                  Order Information
                </Badge>
                <span className="font-mono text-xs text-muted-foreground">
                  SPEC // 01-ENQ
                </span>
              </div>

              <h2 className="text-2xl sm:text-3xl md:text-4xl font-serif font-bold uppercase tracking-tight text-card-foreground leading-tight">
                Why Complete Mechanical Bulls Use an Enquiry Process
              </h2>
            </CardHeader>

            <div className="py-6">
              <Separator className="bg-border" />
            </div>

            <CardContent className="p-0 space-y-5 text-muted-foreground font-sans text-base sm:text-lg leading-relaxed">
              <p className="text-card-foreground/90 font-medium">
                Mechanical bulls are not identical parcel products. A buyer may need to confirm package contents, condition, controller, inflatable, shipping information or site requirements before completing a purchase.
              </p>
              <p>
                An enquiry also allows the buyer to reference the exact product rather than assuming that information from another machine applies to the one they want.
              </p>
              <p>
                Visible product pricing still provides a starting point, while the enquiry handles order-specific details.
              </p>

              <div className="pt-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 border-t border-border mt-8">
                <p className="text-xs font-mono text-muted-foreground uppercase tracking-wider">
                  Direct equipment consultation available nationwide
                </p>
                <Button asChild variant="outline" size="sm" className="rounded-none border-border hover:bg-muted text-card-foreground font-mono text-xs uppercase tracking-wider">
                  <Link to="/ContactPage" className="inline-flex items-center gap-2">
                    <span>Contact Sales Desk</span>
                    <ArrowRight className="size-3.5 text-primary" />
                  </Link>
                </Button>
              </div>
            </CardContent>
          </Card>
        </motion.div>
      </div>
    </section>;
}